<template>
  <!--product body-->
  <div class="new_body">

    <div class="banner-top"><img src="@/assets/20220129/1643429165608386.jpg"></div>
    <div class="sevenpage">
      <div class="main">
        <div class="ntitle hidden-xs" style="margin-top:30px;margin-bottom:30px;">
          <h5>
            <img src="@/images/tb1.png" class="img-responsive" style="float:left;padding-top: 8px;"> 当前位置：
            <router-link to="/home" class="ms-channel-path-index">首页</router-link>
            >>
            <router-link to="/news" class="ms-channel-path-link"> 新闻中心</router-link>
          </h5>
        </div>

        <div>
          <div class="product-fl text-center hidden-xs" style="margin-bottom: 40px;margin-right: 40px;">
            <div class="pro-title"><span>NEWS CENTER</span>
              <p>新闻中心</p>
            </div>

            <!-- left menus -->
            <div class="treebox">
              <ul class="menu">

                <li class="level1" v-for="item of menuList">
                  <router-link :to="item.url">
                    {{item.title}}
                    <i class="down"></i>
                  </router-link>
                </li>

              </ul>

            </div>

            <Contract />

          </div>

          <!-- new list -->
<!--          <div class="nrbf">
            <ul class="nlist-box">
              <li style="float:left;margin:10px 0;border-bottom:1px dashed #888888" v-for="news of page.data">
                <div class="date-time"><strong style="font-size:30px;">{{news.day}}</strong> <br>
                  {{news.date}}
                </div>
                <div class="xinwennr">
                  <router-link class="Themetxthover"
                                         :to="news.url"
                                         style="font-size:16px;line-height:36px; font-weight:bold">
                    {{news.title}}
                  </router-link>
                  <p>{{news.desc}}</p>
                </div>
                <div style="clear: both;"></div>
              </li>

            </ul>
            <div class="pagebar">
              <div class="pagination">
                <router-link class="page-item page-link hidden-sm" to="/" title="首页">首页</router-link>
                <a class="page-item page-link st" href="" title="上一页"><<</a>
                <a>1/1</a>
                <a class="page-item page-link st" href="" title="下一页">>></a>
                <a class="page-item page-link hidden-sm" href="" title="尾页">尾页</a>
              </div>
            </div>
          </div>-->

          <main>
            <router-view></router-view>
          </main>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contract from './Contract.vue'
import * as newApi from "@/components/oh/newsApi";
export default {
  name: 'News',
  components: {
    Contract,
  },
  data() {
    return {
      menuList: []
    }
  },
  created () {
    this.menuList = newApi.getNewsLeftMenuList()
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ntitle h5 * {
  color: white;
  font-size: 14px;
  padding: 0 8px
}

.ntitle h5 *:hover {
  font-weight: bold
}
</style>
